var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M847.1 184.5C781.4 154.4 712 133.1 640.8 121c-9.7 17.4-18.6 35.4-26.4 53.7-75.9-11.4-153.1-11.4-229 0-7.9-18.4-16.7-36.3-26.4-53.7-71.3 12.2-140.7 33.5-206.5 63.6C21.9 377.9-13.5 566.2 4.2 751.9c76.5 56.5 162 99.5 253 127 20.5-27.6 38.6-56.8 54.2-87.4-29.6-11.1-58.1-24.7-85.3-40.7 7.2-5.2 14.2-10.5 20.9-15.7 160.2 75.3 345.7 75.3 505.9 0 6.8 5.6 13.8 10.9 20.9 15.7-27.2 16.1-55.9 29.7-85.5 40.8 15.6 30.6 33.7 59.8 54.2 87.3 91.1-27.5 176.7-70.4 253.2-126.9 20.8-215.3-35.4-402-148.6-567.5zM333.9 637.7c-49.3 0-90.1-44.8-90.1-99.8s39.3-100.2 89.9-100.2 91 45.1 90.1 100.2c-.8 55.1-39.7 99.8-89.9 99.8zm332.2 0c-49.4 0-90-44.8-90-99.8s39.3-100.2 90-100.2 90.8 45.1 89.9 100.2-39.6 99.8-89.9 99.8z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.4ec2553b64b6d433654db74f2e29caa9.svg";
export { ForwardRef as ReactComponent };